export default __webpack_public_path__ + "static/media/css3.68ba79f5.png";